import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-layoutbuilder',
  templateUrl: './layoutbuilder.component.html',
  styleUrls: ['./layoutbuilder.component.scss']
})
export class LayoutbuilderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
